/** Ayuda / Manual del módulo Presupuestos SA — guía interactiva + PDF descargable. */
import React, { useState, useEffect } from 'react';
import api from '@/api/axios';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { toast } from 'sonner';
import { CaretDown, CaretRight, FilePdf } from '@phosphor-icons/react';

const descargar = async (tipo) => {
  try {
    const res = await api.get('/sa/manual/pdf', { params: { tipo }, responseType: 'blob', timeout: 60000 });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = tipo === 'admin' ? 'Manual_Admin_Permisos_Presupuestos_SA.pdf' : 'Manual_Presupuestos_SA.pdf';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 2000);
  } catch (e) { toast.error('No se pudo descargar el manual'); }
};

export const ManualSA = ({ onClose }) => {
  const [data, setData] = useState(null);
  const [abierta, setAbierta] = useState(0);

  useEffect(() => {
    api.get('/sa/manual').then((r) => setData(r.data)).catch(() => toast.error('No se pudo cargar el manual'));
  }, []);

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent aria-describedby={undefined} className="sm:max-w-[680px] max-h-[92vh] overflow-y-auto" data-testid="manual-sa-dialog">
        <DialogHeader><DialogTitle>Manual de uso — Presupuestos SA</DialogTitle></DialogHeader>
        {!data ? <p className="text-sm text-[var(--text-muted)]">Cargando…</p> : (
          <div className="space-y-2">
            <div className="flex gap-2 flex-wrap">
              <Button size="sm" variant="outline" onClick={() => descargar('operativo')} data-testid="manual-pdf-btn">
                <FilePdf size={15} className="mr-1 text-red-500" /> Descargar manual (PDF)
              </Button>
              {data.es_admin && (
                <Button size="sm" variant="outline" onClick={() => descargar('admin')} data-testid="manual-admin-pdf-btn">
                  <FilePdf size={15} className="mr-1 text-amber-500" /> Manual administrativo de permisos (PDF)
                </Button>
              )}
            </div>
            <p className="text-[11px] text-[var(--text-muted)]">{data.subtitulo} · Guía paso a paso desde la solicitud hasta la aprobación.</p>
            <div className="border border-[var(--border)] rounded-lg divide-y divide-[var(--border)]">
              {(data.secciones || []).map((s, i) => (
                <div key={i}>
                  <button type="button" className="w-full flex items-center justify-between px-3 py-2.5 text-left"
                    onClick={() => setAbierta(abierta === i ? -1 : i)} data-testid={`manual-seccion-${i}`}>
                    <span className="text-sm font-bold text-[var(--text)]">{s.titulo}</span>
                    {abierta === i ? <CaretDown size={14} className="text-[#0EA5E9]" /> : <CaretRight size={14} className="text-[var(--text-muted)]" />}
                  </button>
                  {abierta === i && (
                    <ul className="px-4 pb-3 space-y-1.5">
                      {s.puntos.map((p, j) => (
                        <li key={j} className="text-xs text-[var(--text-muted)] flex gap-1.5">
                          <span className="text-[#0EA5E9] shrink-0">{s.checklist ? '☐' : '•'}</span>{p}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
